import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import store from 'wave_solder_pallets/store';
import App from 'wave_solder_pallets/App';
import Cart from 'wave_solder_pallets/Cart';

document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.getElementById('quote-form');
  const cartContainer = document.getElementById('cart-form');

  if (appContainer != null) {
    render(
      <Provider store={store}>
        <App />
      </Provider>,
      appContainer,
    );
  }

  if (cartContainer) {
    render(
      <Provider store={store}>
        <Cart />
      </Provider>,
      cartContainer,
    );
  }
});
